import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { AssetHistoryPage } from "./AssetHistoryPage";
import { SharePage } from "./SharePage";
import { ShopPage } from "./ShopPage";
import { applyStoredTheme } from "./theme-toggle";
// oxlint-disable-next-line import/no-unassigned-import -- the page's stylesheet, imported for its side effect
import "./share.css";

/**
 * The public pages' own entry (share.html): an item (/p/<token>), a shop
 * (/t/<slug>, spec 2026-09-26) or an object's history (/e/<token>, spec
 * bitácora por enlace). No router, no session, no Sentry, no service
 * worker -- a stranger's phone downloads only this.
 */
// The visitor's light or dark, before the first paint.
applyStoredTheme();

function pageFor(pathname: string): ReactNode {
  if (pathname.startsWith("/t/")) return <ShopPage />;
  if (pathname.startsWith("/e/")) return <AssetHistoryPage />;
  return <SharePage />;
}

const root = document.getElementById("root");
if (root !== null) {
  createRoot(root).render(
    <StrictMode>
      {pageFor(window.location.pathname)}
    </StrictMode>,
  );
}
